module.exports = {"340304001":"大庆街道","340304002":"纬四街道","340304003":"钓鱼台街道","340304004":"张公山街道","340304005":"朝阳街道","340304100":"秦集镇","340304101":"马城镇","340304200":"长青乡","340304401":"安徽怀远马城经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340304.json
// module id = 1166
// module chunks = 0